import * as Tone from 'tone';
import AudioEffect from '../effects/audio/AudioEffect';
import AudioChain from './AudioChain';
import LiveState from './LiveState';
class ReturnTrack {
    constructor() {
        this.gainNode = new Tone.Gain(0, "decibels");
        this.chain = new AudioChain();
        this.gainNode.connect(LiveState.Master.input);
        this.chain.output().connect(this.gainNode);
        LiveState.returnTracks.push(this);
    }
    get volume() {
        return this.output.gain.value;
    }
    set volume(volume) {
        this.output.gain.value = volume;
    }
    get input() {
        return this.chain.input;
    }
    get output() {
        return this.gainNode;
    }
    getDevice(name) {
        if (name === 'Mixer') {
            return this;
        }
        else {
            console.error(`Unknown device ${name}`);
        }
    }
    insert(object, position) {
        if (object instanceof AudioEffect) {
            this.chain.insert(object, position);
        }
        else {
            throw Error('Incompatible object inserted into track');
        }
    }
}
export default ReturnTrack;
//# sourceMappingURL=ReturnTrack.js.map